<template>
  <div :class="tplHidden ? 'tplHidden' : ''">
    <main>
      <section class="fk-contents">
        <h2 class="title-lv2 mb15">{{getSelectItem.item.category_name}}<br>{{getSelectItem.setmenu.category_name}}</h2>
        <div class="mod-item-box">
          <div class="item-image"><img :src="getSelectItem.item.image_url" :alt="getSelectItem.item.category_name"></div>
          <div class="item-price">
            <small>{{text.ItemType}}</small>
            <strong>¥{{displayThousandsSeparator(unitPrice.price)}}</strong>
            <small>{{getTaxDisplay(unitPrice.taxType)}}</small>
          </div>
        </div>
        <div class="set-item">
          <div class="mod-general-box set-item-box">
            <h3 class="set-item-name" v-html="displayCategoryName(getSelectItem.setmenu.category_name)"></h3>
            <div class="item-wrap" v-for="(item, index) in selectedSidemenu" :key="index">
              <div class="item-image"><img :src="importImageUri(item.image_url)" :alt="item.category_name"></div>
              <div class="item-name"><small v-if="visibleChangeButton(index)">▶︎{{$t('SetMenuDetail.Selected')}}{{item.setmenu_name}}</small>{{item.item_name}}</div>
              <div class="item-change"><a href="#" class="btn-base btn-negative js-modal_open" data-target="modal01" @click.prevent="modalOpen($event, index)" v-if="visibleChangeButton(index)">{{$t('General.Change')}}</a></div>
            </div>
          </div>
        </div>
        <p class="mod-form-btn"><a href="#" class="btn-base btn-main" @click.prevent="addCart($event)">{{$t('SetMenuDetail.PutCart')}}</a></p>
      </section>
    </main>

    <!-- 再選択モーダル -->
    <div v-for="(items, index) in setmenuDetails" :key="index" id="modal01" class="modal-box js-modal" :class="{'is-open': modal[index].isOpen}">
      <div class="modal-box_bg"></div>
      <div class="modal-content">
        <h2 class="title-lv2 title-change-item">{{$t('SetMenuDetail.Modal.Heading')}}</h2>
        <div class="change-item-box">
          <ul class="change-item-list">
            <li v-for="(item, index2) in items.setitem_list" :key="index2">
              <input type="radio" :name="`sidemenu-${index}`" :id="'modal' + index + '-' + index2" :value="item.item_cd" v-model="modalChecked[index].itemCd" :checked="modalChecked[index].itemCd" @change="modalClose($event, index)">
              <label :for="'modal' + index + '-' + index2">
                <span class="item-image"><img :src="importImageUri(item.image_url)" :alt="item.item_name"></span>
                <span class="item-name">{{item.item_name}}<br>{{getPriceDiff(item.price_diff)}}</span>
              </label>
            </li>
          </ul>
        </div>
        <p class="modal-close js-modal_close" @click="modalClose($event, index)">{{$t('General.Close')}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import CommonMixin from '@/mixins/CommonMixin'
import DisplayErrorMixin from '@/mixins/DisplayErrorMixin'
export default {
  name: 'FKMOMenuDetail',
  mixins: [ CommonMixin, DisplayErrorMixin ],
  data () {
    return {
      // (画面表示用)選択中のサイドメニュー
      selectedSidemenu: [],
      // (画面表示用)モーダル内に表示するサイドメニューのリスト
      setmenuDetails: [],
      // (画面表示用)モーダルの開閉状態をコントロールする
      modal: [],
      // (画面表示用)初期選択状態(checked)のコントロール
      modalChecked: [],
      tplHidden: true,
      originalConfiguration: null, // 元構成を保持する
      unitPrice: {
        price: 0,
        taxType: 0
      },
      text: {
        ItemType: null // 単品 or クーポン
      }
    }
  },
  computed: {
    getServerTime () {
      return this.$store.getters.serverTime
    },
    getSelectItem () {
      return this.$store.getters.selectItem
    },
    getCart () {
      return this.$store.getters.cart
    },
    getSelectStore () {
      return this.$store.getters.selectStore
    },
    getDisabledButton () {
      return this.$store.getters.disabledButton
    }
  },
  methods: {
    addCart: function (event) {
      if (this.getDisabledButton) {
        return false
      }

      // 選択したセットメニューのリストをStoreに書き込む
      // 初期化
      const selectItem = {
        coupon_cd: this.getSelectItem.coupon_cd || null,
        item: this.getSelectItem.item,
        quantity: this.getSelectItem.quantity,
        setmenu: this.getSelectItem.setmenu,
        setmenu_details: [], // セットメニュー詳細はリセットする
        isSelectable: this.getSelectItem.isSelectable
      }
      // カートを取得する
      const cart = this.getCart

      // 元構成からsetmenu_detailsにデータを追加していく
      for (let i = 0; i < this.originalConfiguration.setmenu_details.length; i++) {
        let item = this.originalConfiguration.setmenu_details[i]
        let setitem = null
        let itemCd = null

        // 構成変更可能
        selectItem.isSelectable = true

        if (item.is_main_menu) {
          setitem = item.setitem_list[0]
          setitem.is_main_menu = true // メインメニュー情報を追加
          selectItem.setmenu_details.push(item.setitem_list[0])
        } else {
          // サイドメニューを追加する
          // モーダルで選択中の商品コードを検索する
          for (let h = 0; h < this.modalChecked.length; h++) {
            // 検索対象は元構成の現在のイテレータと一致する、モーダルで選択中の商品のindex
            if (Number(this.modalChecked[h].index) === i) {
              itemCd = this.modalChecked[h].itemCd
              break
            }
          }
          // 商品コードと一致するsetitemを検索する
          for (let j = 0; j < item.setitem_list.length; j++) {
            if (item.setitem_list[j].item_cd === itemCd) {
              setitem = item.setitem_list[j]
              setitem.is_main_menu = false // メインメニュー情報を追加
              setitem.isVisible = true
              selectItem.setmenu_details.push(setitem)
              break
            }
          }
        }
      }

      // setmenu_detailsが0件の場合はエラーとして処理を中断する
      if (selectItem.setmenu_details.length === 0) {
        this.errorFromApp('ErrorMsg.ERR_999', selectItem)
        return false
      }

      // 変更内容変更か否かで処理を切り分ける
      if (this.isChangeCartNumber()) {
        // 更新なので対象アイテムを変更
        cart.item_list[sessionStorage.getItem('changeCartNumber')] = selectItem
      } else {
        // 新規なので追加
        cart.item_list.push(selectItem)
      }
      this.$store.dispatch('setCart', cart)

      if (this.isChangeCartNumber()) {
        // 内容変更の時は履歴に載せない
        this.$router.go(-1)
        this.$router.replace({
          name: 'Cart',
          params: { requestBlock: '1' }
        })
      } else {
        this.$router.push({ name: 'Cart' })
      }
      sessionStorage.removeItem('changeCartNumber')
    },
    initDetailChange: function () {
      // カート番号の変更パラメータが渡されてなければ新規追加として扱う
      if (!this.isChangeCartNumber()) {
        return false
      }

      // 変更対象のアイテムを取得する
      let item = Object.assign({}, this.getCart.item_list[sessionStorage.getItem('changeCartNumber')])
      this.$store.dispatch('setSelectItem', item)
    },
    // モーダル
    modalOpen: function (event, index) {
      this.modal[index].isOpen = true
      this.resizeModalHeight()
      this.preventBackgroundScrolling(true)
    },
    modalClose: function (event, index) {
      event.preventDefault()
      this.modal[index].isOpen = false
      this.preventBackgroundScrolling(false)

      // モーダルで選択したサイドメニューを特定する
      let item
      for (let i in this.setmenuDetails[index].setitem_list) {
        // モーダルでチェックしたitem_cdと、セットメニューリストのitem_cdが一致する商品を特定する
        if (this.modalChecked[index].itemCd === this.setmenuDetails[index].setitem_list[i].item_cd) {
          item = this.setmenuDetails[index].setitem_list[i]
          item.setmenu_name = this.setmenuDetails[index].setitem_category_name
          break
        }
      }
      // サイドメニューの選択状態を更新する
      this.selectedSidemenu[index] = item
    },
    getPriceDiff: function (price) {
      if (price > 0) {
        return `+${this.displayThousandsSeparator(price)}${this.$i18n.t('General.Yen')}`
      } else if (price < 0) {
        return `${this.displayThousandsSeparator(price)}${this.$i18n.t('General.Yen')}`
      } else {
        return ''
      }
    },
    // 構成情報変更フラグ
    isSelectable: function (setmenuDetail) {
      let ret = false // 構成情報変更フラグ

      // サイドメニューの構成情報が2つ以上含まれていれば構成情報を変更可能とする
      setmenuDetail.filter(function (item, index) {
        if (item.setitem_list.length > 1) {
          ret = true
        }
      })

      return ret
    },
    init: function () {
      this.setDisabledButton(true)
      // axios callback内からの参照用
      let that = this

      // カテゴリー一覧を取得する
      let params = {
        'store_cd': this.getSelectStore.store_cd,
        'setmenu_cd': this.getSelectItem.setmenu.category_cd,
        'coupon_cd': this.getSelectItem.coupon_cd,
        'receive_method': Number(this.getCart.receive_method),
        language: sessionStorage.getItem('lang')
      }
      this.callApi('SetMenuDetail',
        params
      )
      // let stuburl = `/static/stub/setmenu_detail_${this.getSelectItem.setmenu.category_cd}.json`
      // this.axios.get(stuburl)
        .then(function (res) {
          if (res.data.result) {
            const setmenuDetails = res.data.value.setmenu_details

            if (that.isSelectable(setmenuDetails)) {
              // 構成変更が可能な商品が含まれているので詳細画面を表示する
              that.tplHidden = false

              // オリジナルの商品構成をバックアップしておく
              that.originalConfiguration = res.data.value

              // 初期の選択状態を定義
              for (let i in setmenuDetails) {
                // メインメニュー(is_main_menu===true)であれば非表示とする。
                // 非メインメニュー(is_main_menu===false)であれば、各種パラメータを設定して画面に表示する
                if (!setmenuDetails[i].is_main_menu) {
                  // モーダルの開閉パラメータを設定
                  that.modal.push({ isOpen: false })
                  // 1つめの要素を選択中にセット
                  that.modalChecked.push({
                    index: i, // 元構成のindexを保持する
                    itemCd: setmenuDetails[i].setitem_list[0].item_cd
                  })
                  // 表示するデータをセット
                  let selectedSidemenu = setmenuDetails[i].setitem_list[0]
                  selectedSidemenu.setmenu_name = setmenuDetails[i].setitem_category_name
                  that.selectedSidemenu.push(selectedSidemenu)
                  that.setmenuDetails.push(setmenuDetails[i])
                } else {
                  // メインメニューの場合
                  // 単価をセットする
                  that.unitPrice.price = setmenuDetails[i].setitem_list[0].price
                  that.unitPrice.taxType = that.getSelectItem.item.tax_type
                }
              }

              if (that.getSelectItem.coupon_cd !== null && that.getSelectItem.coupon_cd !== undefined && that.getSelectItem.coupon_cd.length > 0) {
                // クーポン商品の場合
                // 商品種別に「クーポン」を表示する
                that.text.ItemType = that.$i18n.t('General.Coupon')
                // 割引価格を表示する
                const selectItem = that.getSelectItem
                if (that.getCart.receive_method === '1') {
                  that.unitPrice.price = selectItem.item.discount_price.receive_method_1
                } else {
                  that.unitPrice.price = selectItem.item.discount_price.receive_method_2
                }
                that.unitPrice.taxType = that.getSelectItem.item.tax_type
                that.$store.dispatch('setSelectItem', selectItem)
              } else {
                // 通常のセット商品の場合
                // 商品種別に「単品」を表示する
                that.text.ItemType = that.$i18n.t('General.Single')
              }

              // 内容の変更で遷移してきた場合、選択状態を更新する。
              if (that.isChangeCartNumber()) {
                // カートから対象商品を取り出す
                const item = Object.assign({}, that.getCart.item_list[sessionStorage.getItem('changeCartNumber')])

                // モーダルの選択状態をリセットする
                that.modalChecked = []
                // 再描画用のselectedSidemenu
                let selectedSidemenu = []

                for (let h in item.setmenu_details) {
                  if (item.setmenu_details[h].isVisible) {
                    that.modalChecked.push({
                      index: h, // 元構成のindexを保持する
                      itemCd: item.setmenu_details[h].item_cd
                    })
                    selectedSidemenu.push(item.setmenu_details[h])
                  }
                }
                // 再描画
                that.selectedSidemenu = selectedSidemenu
              }
            } else {
              // 全ての商品が構成変更が不可能なのでカートに追加する
              // 選択したセットメニューのリストをStoreに書き込む
              // 初期化
              const selectItem = {
                coupon_cd: that.getSelectItem.coupon || null,
                item: that.getSelectItem.item,
                quantity: that.getSelectItem.quantity,
                setmenu: that.getSelectItem.setmenu,
                setmenu_details: [] // セットメニュー詳細はリセットする
              }

              // カートを取得する
              const cart = that.getCart

              for (let n = 0; n < setmenuDetails.length; n++) {
                if (setmenuDetails[n].setitem_list.length > 0) {
                  selectItem.setmenu_details.push(setmenuDetails[n].setitem_list[0])
                }
              }

              if (selectItem.setmenu_details.length === 0) {
                that.errorFromApp('ErrorMsg.ERR_999', selectItem)
                return false
              }

              // 構成変更不可フラグを立てる
              selectItem.isSelectable = false

              // カートに追加する
              cart.item_list.push(selectItem)
              that.$store.dispatch('setCart', cart)

              // (history.back対策)遷移先の履歴に上書きする
              that.$router.replace({ name: 'Cart' })
            }

            // 読み込み完了
            that.loadComplete = true
          } else {
            that.errorFromApi(res.data.errorCode, res.data.error)
          }
        })
        .catch((error) => {
          that.errorFromAxios(error)
        })
        .finally(() => {
          that.setDisabledButton(false)
        })
    },
    isChangeCartNumber: function () {
      // changeCartNumberが渡されていなければ新規とする
      if (sessionStorage.getItem('changeCartNumber') === null) {
        return false
      }
      // changeCartNumberに数値以外が含まれていたら新規とする
      if (sessionStorage.getItem('changeCartNumber').match(/^[0-9]+$/) === null) {
        return false
      }
      // カートが0件であれば新規とする
      if (this.getCart.item_list.length === 0) {
        return false
      }
      return true
    },
    visibleChangeButton: function (index) {
      // indexで指定されたサイドメニューの変更ボタンを表示するかどうかを判定する
      try {
        // setitem_listの要素数が2以上
        if (this.setmenuDetails[index].setitem_list.length >= 2) {
          return true
        }
        return false
      } catch (ex) {
        // 例外になるような場合は非表示とする
        return false
      }
    },
    displayCategoryName: function (name) {
      if (!name.match('\r\n')) {
        return name
      }
      return name.replace(/\r\n/g, '<br>')
    },
    /** Resizeイベントの登録・削除とモーダルの高さ調整 */
    resizeModalHeight: function () {
      // NOTE window.innerHeightから差し引く数値は、CSS(.change-item-box)を参考にした
      const node = document.getElementsByClassName('change-item-box')
      for (let i = 0; i < node.length; i++) {
        node[i].style.maxHeight = `${window.innerHeight - 112}px`
      }
    },
    addResizeListener: function () {
      window.addEventListener('resize', this.resizeModalHeight, false)
    },
    removeResizeListener: function () {
      window.removeEventListener('resize', this.resizeModalHeight, false)
    }
    /** Resizeイベントの登録・削除とモーダルの高さ調整 */
  },
  beforeMount () {
    // サーバー時間
    this.serverTime = this.getServerTime

    // 内容の変更
    this.initDetailChange()

    this.addResizeListener()

    this.init()
  },
  beforeUpdate () {
    this.restoreScaleRate('default') // 拡大縮小のロックを開放
  },
  destroyed () {
    this.removeResizeListener()
    this.restoreScaleRate('reset') // scaleをリセット
  }
}
</script>

<style scoped>
.is-open {
  display: block;
}
.tplHidden {
  visibility: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/SetMenuDetail.vue